export const faq = {
  badge: "FAQ",
  title: "Frequently asked questions",
  subtitle: "Everything you need to know about DONKEY TRAVEL",
  items: {
    q1: {
      question: "How does the Nights system work?",
      answer:
        "It is a direct exchange between two owners. You agree on dates (simultaneous or deferred) and terms. No points, no complicated calculations, just human connection.",
    },
    q2: {
      question: "Do I have to exchange at the same time?",
      answer:
        "No! That's the beauty of our flexible system. You can host Jean in April and stay at his place in October. It also allows you to meet during key handover!",
    },
    q3: {
      question: "How are members verified?",
      answer:
        "All members must be verified Airbnb owners. We also verify the identity, property and Airbnb reviews of each member to ensure community safety.",
    },
    q4: {
      question: "What happens if there's a problem?",
      answer:
        "Our support team is available 7 days a week to assist you. In addition, our review and rating system helps maintain a trusted community and quickly resolve any issues.",
    },
    q5: {
      question: "Are there any hidden fees?",
      answer:
        "No hidden fees. You only pay your annual subscription according to the geographic area chosen. Exchanges are then completely free, with no commission or additional fees.",
    },
    q6: {
      question: "Can I choose who stays at my place?",
      answer:
        "Absolutely! You have total control. You can view profiles, read reviews and accept or decline each exchange request according to your preferences.",
    },
    q7: {
      question: "Is my property insured during exchanges?",
      answer:
        "Yes, all exchanges are covered by our partner insurance. In addition, we recommend checking your home insurance for optimal protection.",
    },
    q8: {
      question: "How far in advance should I book?",
      answer:
        "It depends on each owner. Some accept last-minute bookings, others prefer to plan several months in advance. We recommend booking at least 2-3 weeks in advance.",
    },
  },
  cta: {
    title: "Do you have other questions?",
    subtitle: "Our team is here to help you start your DONKEY TRAVEL adventure",
    button: "Contact us",
  },
};
